import React from "react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { referenzen: r } = content;

const Row = ({ logos, cls }) => (
  <div className="marquee-wrap relative overflow-hidden py-4">
    <div className={`marquee-track ${cls}`}>
      {[...logos, ...logos].map((logo, i) => (
        <div
          key={i}
          aria-hidden={i >= logos.length ? "true" : undefined}
          className="flex h-[48px] w-[124px] shrink-0 items-center justify-center px-3 opacity-75 hover:opacity-100 sm:h-[56px] sm:w-[186px] sm:px-6"
          style={{ transition: "opacity .4s ease" }}
        >
          <img
            src={logo.src}
            alt={`Logo ${logo.name}`}
            title={logo.name}
            loading="eager"
            decoding="async"
            className="h-[calc(var(--lh)*0.78)] w-auto max-w-full object-contain sm:h-[var(--lh)]"
            style={{ "--lh": `${logo.h || 33}px`, filter: "grayscale(1) contrast(1.05)" }}
          />
        </div>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#f5f6f4] to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#f5f6f4] to-transparent" />
  </div>
);

export const LogoStrip = () => {
  const logos = r.logoStrip.slice(0, 26);
  const half = 13;
  const ref = React.useRef(null);
  React.useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      ([entry]) => el.setAttribute("data-marquee-paused", entry.isIntersecting ? "false" : "true"),
      { rootMargin: "100px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <section
      ref={ref}
      data-testid="logo-slider"
      className="has-lines overflow-hidden border-b border-[#dfe2e0] bg-[#f5f6f4] py-20 md:py-24"
    >
      <FlowLines color="#0F9D6E" opacity={[0.055, 0.045]} />
      <Container>
        <Reveal>
          <div className="mx-auto max-w-[820px] text-center">
            <Label>{r.stripLabel}</Label>
            <AccentH2 className="mt-6 text-3xl font-bold leading-[1.18] text-[#1e2532] md:text-[42px]">{r.stripH2}</AccentH2>
            <p className="mx-auto mt-7 max-w-[640px] text-[17px] leading-[1.8] text-[#565f70]">{r.stripText}</p>
          </div>
        </Reveal>
      </Container>

      <div className="mt-14">
        <Row logos={logos.slice(0, half)} cls="" />
        <Row logos={logos.slice(half)} cls="marquee-slow" />
      </div>
    </section>
  );
};
